<template>
  <div class="component-container">
    <div v-if="showButtons" class="button-group-container">
      <el-popconfirm
        :title="$t('table.CREATE_A_LINE_DESCRIPTION')"
        @confirm="handleCreate"
        popper-class="popper"
      >
        <el-button
          v-if="createButton"
          class="button"
          type="primary"
          round
          :disabled="createButtonDisabled"
          slot="reference"
          >{{ $t('table.CREATE_A_LINE') }}</el-button
        >
      </el-popconfirm>
      <el-popconfirm
        :title="$t('table.COPY_A_LINE_DESCRIPTION')"
        @confirm="handleCopy"
        popper-class="popper"
      >
        <el-button
          v-if="copyButton"
          class="button"
          type="primary"
          round
          :disabled="copyButtonDisabled"
          slot="reference"
          >{{ $t('table.COPY_A_LINE') }}</el-button
        >
      </el-popconfirm>
      <el-popconfirm
        :title="$t('table.DELETE_LINES_DESCRIPTION')"
        @confirm="handleDelete"
        popper-class="popper"
      >
        <el-button
          v-if="deleteButton"
          class="button"
          type="danger"
          round
          :disabled="deleteButtonDisabled"
          slot="reference"
          >{{ $t('table.DELETE_LINES') }}</el-button
        >
      </el-popconfirm>
    </div>
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item
        v-for="(row, indexs) in rows"
        :key="row.rowId"
        class="list"
        :name="indexs"
        :title="showtitle(row, indexs)"
      >
        <el-row
          v-for="(column, index) in columns"
          :key="column.colId"
          class="list_row"
        >
          <el-col :span="24" class="list_label">
            <label>{{ column.label }}</label>
          </el-col>
          <el-col :span="24" class="list_cont">
            <span
              v-if="showCellContent(null, indexs, index)"
              class="cell-content"
              :style="fontColor(indexs, index)"
              >{{ row[column.colId].value }}</span
            >
            <jtInput
              v-if="showCellContent('jtInput', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              :minLength="column.component.property.minLength"
              :maxLength="column.component.property.maxLength"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jt-email
              v-if="showCellContent('jtEmail', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jt-phone
              v-if="showCellContent('jtPhone', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jt-date
              v-if="showCellContent('jtDate', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              :format="column.component.property.format"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jt-time
              v-if="showCellContent('jtTime', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              :format="column.component.property.format"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jt-date-time
              v-if="showCellContent('jtDateTime', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              :format="column.component.property.format"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jt-id-card
              v-if="showCellContent('jtIdCard', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              :types="column.component.property.types"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @IDCheck="(data) => handleIDCheck(data, indexs, index)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jt-id-card-global
              v-if="showCellContent('jtIdCardGlobal', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jt-single-project
              v-if="showCellContent('jtSingleProject', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              :minLength="column.component.property.minLength"
              :maxLength="column.component.property.maxLength"
              :suggestions="column.component.property.suggestions"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jt-group-project
              v-if="showCellContent('jtGroupProject', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              :minLength="column.component.property.minLength"
              :maxLength="column.component.property.maxLength"
              :suggestions="column.component.property.suggestions"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jtSelect
              v-if="showCellContent('jtSelect', indexs, index)"
              :value="row[column.colId].value"
              :tooltip="column.component.property.tooltip"
              :compWidth="column.component.property.compWidth"
              :options="
                row[column.colId].options || column.component.property.options
              "
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jtGroupSelect
              v-if="showCellContent('jtGroupSelect', indexs, index)"
              :value="row[column.colId].value"
              :tooltip="column.component.property.tooltip"
              :compWidth="column.component.property.compWidth"
              :options="
                row[column.colId].options || column.component.property.options
              "
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              @beforeSelect="handleBeforeSelect(row, column)"
              :ref="generateRef(indexs, index)"
            />
            <jtImage
              v-if="showCellContent('jtImage', indexs, index)"
              :src="row[column.colId].value"
              :tooltip="column.component.property.tooltip"
              :thumbnailWidth="column.component.property.thumbnailWidth"
              :thumbnailHeight="column.component.property.thumbnailHeight"
              :uploadAction="row[column.colId].uploadAction"
              :supportTypes="column.component.property.supportTypes"
              :editable="column.editable && row[column.colId].editable"
              :supportSize="column.component.property.supportSize"
              :types="column.component.property.types"
              :supportMinWidth="column.component.property.supportMinWidth"
              :supportMaxWidth="column.component.property.supportMaxWidth"
              :supportMinHeight="column.component.property.supportMinHeight"
              :supportMaxHeight="column.component.property.supportMaxHeight"
              :scaleWH="column.component.property.scaleWH"
              @delete="() => handleImageDelete(indexs, index)"
              @success="
                (response) => handleImageUploadSuccess(indexs, index, response)
              "
              @change="
                (file, uploadAction, scaleWH) =>
                  handleImgchange(file, uploadAction, scaleWH, indexs, index)
              "
              :ref="generateRef(indexs, index)"
            />
            <jtMusic
              v-if="showCellContent('jtMusic', indexs, index)"
              :src="row[column.colId].value"
              :musicName="row[column.colId].musicName"
              :tooltip="column.component.property.tooltip"
              :width="column.component.property.width"
              :editable="column.editable && row[column.colId].editable"
              :height="column.component.property.height"
              :uploadAction="row[column.colId].uploadAction"
              :supportTypes="column.component.property.supportTypes"
              :supportSize="column.component.property.supportSize"
              @delete="() => handleMusicDelete(indexs, index)"
              @success="
                (response) => handleMusicUploadSuccess(indexs, index, response)
              "
              :ref="generateRef(indexs, index)"
            />
            <jtVideo
              v-if="showCellContent('jtVideo', indexs, index)"
              :src="row[column.colId].value"
              :tooltip="column.component.property.tooltip"
              :width="column.component.property.width"
              :editable="column.editable && row[column.colId].editable"
              :height="column.component.property.height"
              :uploadAction="row[column.colId].uploadAction"
              :supportTypes="column.component.property.supportTypes"
              :supportSize="column.component.property.supportSize"
              @delete="() => handleVideoDelete(indexs, index)"
              @success="
                (response) => handleVideoUploadSuccess(indexs, index, response)
              "
              :ref="generateRef(indexs, index)"
            />
            <jtDistrict
              v-if="showCellContent('jtDistrict', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              :minLength="column.component.property.minLength"
              :maxLength="column.component.property.maxLength"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jtStatusButton
              v-if="showCellContent('jtStatusButton', indexs, index)"
              :compWidth="column.component.property.compWidth"
              :buttonText="column.component.property.buttonText"
              :tooltip="column.component.property.tooltip"
              :editable="column.editable && row[column.colId].editable"
              @buttonSubmit="(tips) => handleButtonSubmit(indexs, tips)"
              :ref="generateRef(indexs, index)"
            />
            <jtRedirectPage
              v-if="showCellContent('jtRedirectPage', indexs, index)"
              :compWidth="column.component.property.compWidth"
              :pageName="column.component.property.pageName"
              :tooltip="column.component.property.tooltip"
              :editable="column.editable && row[column.colId].editable"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              :ref="generateRef(indexs, index)"
            />
            <jtHtmlEdit
              v-if="showCellContent('jtHtmlEdit', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :placeholder="column.component.property.placeholder"
              :tooltip="column.component.property.tooltip"
              :minLength="column.component.property.minLength"
              :maxLength="column.component.property.maxLength"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jtLimitSingle
              v-if="showCellContent('jtLimitSingle', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :options="
                row[column.colId].options || column.component.property.options
              "
              :rowId="row.rowId"
              :colId="column.colId"
              :tag="row[column.colId].tag"
              :tooltip="column.component.property.tooltip"
              :mobile="true"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
            <jtLimitGroup
              v-if="showCellContent('jtLimitGroup', indexs, index)"
              :value="row[column.colId].value"
              :compWidth="column.component.property.compWidth"
              :options="
                row[column.colId].options || column.component.property.options
              "
              :rowId="row.rowId"
              :colId="column.colId"
              :tag="row[column.colId].tag"
              :rows="rows"
              :mobile="true"
              :tooltip="column.component.property.tooltip"
              @datas="(err, data) => handleData(err, indexs, index, data)"
              @enter="handleEnter"
              :ref="generateRef(indexs, index)"
            />
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import _ from 'lodash'

import jtInput from '../input'
import jtEmail from '../email'
import jtPhone from '../phone'
import jtDate from '../date'
import jtTime from '../time'
import jtDateTime from '../datetime'
import jtIdCard from '../id-card'
import jtIdCardGlobal from '../id-cardglobal'
import jtSingleProject from '../single-project'
import jtGroupProject from '../group-project'
import jtSelect from '../select'
import jtImage from '../image'
import jtMusic from '../music'
import jtVideo from '../video'
import jtGroupSelect from '../group-select'
import jtDistrict from '../district'
import jtStatusButton from '../status-button'
import jtRedirectPage from '../redirect-page'
import jtHtmlEdit from '../html-edit'
import jtLimitGroup from '../limit-group'
import jtLimitSingle from '../limit-single'
import * as constants from '../../constants'
import PageModel from '../../models/page'
import { tip } from '@/utils/tool'

export default {
  name: 'jtTablem',
  components: {
    jtInput,
    jtEmail,
    jtPhone,
    jtDate,
    jtTime,
    jtDateTime,
    jtIdCard,
    jtIdCardGlobal,
    jtSingleProject,
    jtGroupProject,
    jtSelect,
    jtImage,
    jtMusic,
    jtGroupSelect,
    jtDistrict,
    jtStatusButton,
    jtRedirectPage,
    jtVideo,
    jtHtmlEdit,
    jtLimitGroup,
    jtLimitSingle,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: true,
    },
    createButton: Boolean,
    copyButton: Boolean,
    deleteButton: Boolean,
  },
  computed: {
    columnsNumber() {
      return _.size(this.columns)
    },
    rowsNumber() {
      return _.size(this.rows)
    },
    showButtons() {
      return this.createButton || this.copyButton || this.deleteButton
    },
    tableMaxHeight() {
      return this.showButtons
        ? `${window.innerHeight - 260}px`
        : `${window.innerHeight - 200}px`
    },
  },
  data() {
    return {
      cellStatusArray: [],
      currentRow: -1,
      currentColumn: -1,
      enter: false,
      multipleSelection: [],
      createButtonDisabled: false,
      copyButtonDisabled: true,
      deleteButtonDisabled: true,
      orginrow: [],
      activeNames: [],
    }
  },

  methods: {
    /** 折叠面板变化 */
    handleChange(val) {
      this.activeNames = val
    },
    /** 根据列表内容显示折叠面板标题 */
    showtitle(obj, index) {
      let column = this.columns
      let role = ''
      let name = ''
      for (var key in obj) {
        let objs = column.find((item) => item.colId == key)
        if (objs !== undefined) {
          if (objs.label === '角色') {
            role = obj[key].value
          }
          if (objs.isName) {
            name = obj[key].value
          }
        }
      }
      if (role || name) {
        let id = index + 1
        if (this.rows.length === 1) {
          return role + '  ' + name
        } else {
          return '(' + id + ')  ' + role + '  ' + name
        }
      } else {
        let id = index + 1
        return '(' + id + ')'
      }
    },
    /** 根据可编辑状态修改文字style */
    fontColor(r, c) {
      const editable =
        this.rows[r].editable &&
        this.columns[c].editable &&
        this.rows[r][this.columns[c].colId].editable

      if (!editable) {
        return {
          color: '#0000c0',
        }
      }
    },
    /** 生成uploadAction */
    buildUploadAction(componentType, pageId, containerId, rowId, colId) {
      return `/api/v2/page/${componentType}/upload?pageId=${pageId}&containerId=${containerId}&rowId=${rowId}&colId=${colId}`
    },
    /** 处理手机端多人项目单选问题 */
    handleBeforeSelect(row, column) {
      const rowIdx = _.findIndex(this.rows, (item) => item.rowId === row.rowId)
      const index = _.findIndex(this.rows, (item) => {
        if (!_.isEmpty(item[column.colId].value)) {
          return true
        }
        return false
      })
      let num = 0
      _.map(this.rows, (item) => {
        if (!_.isEmpty(item[column.colId].value)) {
          num = num + 1
        }
      })
      if (index !== -1) {
        let data = this.rows[index][column.colId].value
        if (index === rowIdx && num === 1) {
          this.rows[rowIdx][column.colId].options =
            this.orginrow[rowIdx][column.colId].options
        } else if (
          !_.isEmpty(this.rows[rowIdx][column.colId].options[0].value)
        ) {
          this.rows[rowIdx][column.colId].options = [
            { label: data, value: data },
            { label: '------', value: '' },
          ]
        }
      } else if (!_.isEmpty(this.rows[rowIdx][column.colId].options[0].value)) {
        this.rows[rowIdx][column.colId].options =
          this.orginrow[rowIdx][column.colId].options
      }
    },

    /** 单元格单击事件 */
    handleCellClick(row, column, cell, event) {
      const rowIdx = _.findIndex(this.rows, (item) => item.rowId === row.rowId)
      const colIdx = _.findIndex(
        this.columns,
        (item) => item.colId === column.property
      )
      // const index = rowIdx * this.columnsNumber + colIdx

      // if (
      //   rowIdx === this.currentRow &&
      //   colIdx === this.currentColumn &&
      //   this.cellStatusArray[index] !== false
      // ) {
      //   return
      // }

      // if (this.cellStatusArray[index] === null) {
      //   this._closePreviousCellEditableStatus()
      //   this._updateCurrentRowAndCurrentColumn(rowIdx, colIdx)
      //   return
      // }
      // 集体项目当同一列其他行已经有数据时，直接发送数据，不用进入编辑状态
      if (
        this.columns[colIdx].component.type === 'jtGroupProject' ||
        this.columns[colIdx].component.type === 'jtGroupSelect' ||
        this.columns[colIdx].component.type === 'jtLimitGroup'
      ) {
        const index = _.findIndex(this.rows, (item) => {
          if (!_.isEmpty(item[this.columns[colIdx].colId].value)) {
            return true
          }
          return false
        })

        // 找到有数据的
        if (index !== -1) {
          let data = this.rows[index][this.columns[colIdx].colId].value

          let isnotnull = !_.isEmpty(
            this.rows[rowIdx][this.columns[colIdx].colId].value
          )
          if (isnotnull) {
            data = ''
          }
          let arr = _.filter(
            this.rows,
            (item) => !_.isEmpty(item[this.columns[colIdx].colId].value)
          )
          if (!(type === 'jtLimitGroup' && arr.length === 1 && isnotnull)) {
            this.$emit('datas', null, rowIdx, colIdx, data, () => {})

            this._closePreviousCellEditableStatus()
            this._updateCurrentRowAndCurrentColumn(rowIdx, colIdx)

            return
          }
        }
      }

      this._closePreviousCellEditableStatus()
      this._openCurrentCellEditableStatus(rowIdx, colIdx)
      this._focus(rowIdx, colIdx)
    },
    /** 根据要求显示单元格内容 */
    showCellContent(cellType, row, column) {
      const type = this.columns[column].component.type
      const index = row * this.columnsNumber + column

      if (
        _.includes(
          ['jtImage', 'jtMusic', 'jtStatusButton', 'jtRedirectPage'],
          type
        )
      ) {
        if (cellType === null || cellType !== type) {
          return false
        } else {
          return true
        }
      }

      if (
        this.cellStatusArray[index] === null ||
        this.cellStatusArray[index] === false
      ) {
        return cellType === null
      } else {
        return cellType === type
      }
    },
    /** 数据处理 */
    handleData(err, row, column, data) {
      this.$emit(
        'datas',
        err,
        row,
        column,
        data,
        (success, otherColumnDataChange) => {
          if (!success) {
            this._focus(row, column)
            this.enter = false
            return
          }

          if (otherColumnDataChange) {
            this._initCellStatusArray()
          }

          if (this.enter) {
            this._goNext(row, column)
            this.enter = false
          } else {
            this._closePreviousCellEditableStatus()
          }
        }
      )
    },

    /**身份证唯一检测 */
    async handleIDCheck(obj, row, column) {
      const { gameId, teamId, olidCardOld, value } = obj
      let data = await PageModel.IDCheck(gameId, teamId, olidCardOld, value)

      if (data.errNo == 0) {
        this.handleData(null, row, column, value)
      } else {
        tip(data.errMsg)
      }
    },

    /** 提交状态按钮 */
    handleButtonSubmit(row, tips) {
      let { rowId } = this.rows[row]
      this.$emit('status-button-submit', rowId, tips)
    },
    /** 图片上传成功事件处理 */
    handleImageUploadSuccess(row, col, response) {
      this.$emit('image-upload-success', row, col, response)
    },
    /** 图片上传事件处理 */
    handleImgchange(file, uploadAction, scaleWH, row, col) {
      this.$emit('image-upload', file, uploadAction, scaleWH, row, col)
    },
    /** 删除图片事件处理 */
    handleImageDelete(row, col) {
      this.$emit('image-delete', row, col)
    },
    /** 音频上传成功事件处理 */
    handleMusicUploadSuccess(row, col, response) {
      this.$emit('music-upload-success', row, col, response)
    },
    /** 删除音频事件处理 */
    handleMusicDelete(row, col) {
      this.$emit('music-delete', row, col)
    },
    /** 视频上传成功事件处理 */
    handleVideoUploadSuccess(row, col, response) {
      this.$emit('video-upload-success', row, col, response)
      setTimeout(() => {
        this.activeNames = [0]
      }, 100)
    },
    /** 删除视频事件处理 */
    handleVideoDelete(row, col) {
      this.$emit('video-delete', row, col)
      setTimeout(() => {
        this.activeNames = [0]
      }, 300)
    },
    /** 回车事件处理 */
    handleEnter() {
      this.enter = true
    },
    /** 生成Ref */
    generateRef(row, column) {
      return `component_${row}_${column}`
    },
    /** 处理行选择改变事件 */
    handleSelectionChange(selection) {
      this.multipleSelection = selection

      let deletable = true
      _.forEach(selection, (item) => {
        deletable = deletable && item.deletable
      })

      const length = selection.length
      this.deleteButtonDisabled = length <= 0 || !deletable
      this.copyButtonDisabled = length !== 1
    },
    /** 处理增加一行按钮 */
    handleCreate() {
      this.$emit('create-a-line')
    },
    /** 处理拷贝一行按钮 */
    handleCopy() {
      this.$emit('copy-a-line', this.multipleSelection)
    },
    /** 处理删除一行按钮 */
    handleDelete() {
      this.$emit('delete-lines', this.multipleSelection)
    },
    /** 初始化表格组件可编辑状态数组 */
    _initCellStatusArray() {
      const size = this.rowsNumber * this.columnsNumber
      if (size === 0) {
        return
      }
      this.cellStatusArray = new Array(size)
      _.fill(this.cellStatusArray, null)
      if (!this.editable) {
        return
      }

      for (let r = 0; r < this.rowsNumber; r++) {
        for (let c = 0; c < this.columnsNumber; c++) {
          const index = r * this.columnsNumber + c
          const editable =
            this.rows[r].editable &&
            this.columns[c].editable &&
            this.rows[r][this.columns[c].colId].editable

          if (
            _.includes(
              ['jtImage', 'jtMusic', 'jtStatusButton', 'jtRedirectPage'],
              this.columns[c].component.type
            )
          ) {
            continue
          }

          if (editable) {
            this.cellStatusArray[index] = true
          }
        }
      }
    },
    /** 获取编辑组件焦点 */
    _focus(row, col) {
      const ref = this.generateRef(row, col)
      const that = this
      _.delay(() => {
        that.$refs[ref][0].focus()
      }, constants.DELAY_TIME)
    },
    /** 焦点跳到下一个组件 */
    _goNext(row, col) {
      const length = this.cellStatusArray.length
      const index = row * this.columnsNumber + col
      for (let i = (index + 1) % length; i !== index; i = (i + 1) % length) {
        if (i === 0) {
          this._closePreviousCellEditableStatus()
          return
        }

        if (
          this.cellStatusArray[i] === null ||
          _.includes(
            ['jtImage', 'jtMusic', 'jtStatusButton', 'jtRedirectPage'],
            this.columns[col].component.type
          )
        ) {
          continue
        }

        const newRow = _.floor(i / this.columnsNumber)
        const newCol = i % this.columnsNumber

        // 集体项目当同一列其他行已经有数据时，跳过该集体项目
        if (this.columns[newCol].component.type === 'jtGroupProject') {
          const index = _.findIndex(this.rows, (item) => {
            if (!_.isEmpty(item[this.columns[newCol].colId].value)) {
              return true
            }
            return false
          })

          if (index !== -1) {
            continue
          }
        }

        this._closePreviousCellEditableStatus()
        this._openCurrentCellEditableStatus(newRow, newCol)
        this._focus(newRow, newCol)
        return
      }
    },
    /** 关闭上一个单元格编辑状态 */
    _closePreviousCellEditableStatus() {
      if (this.currentRow >= 0 && this.currentColumn >= 0) {
        const index = this.currentRow * this.columnsNumber + this.currentColumn
        if (this.cellStatusArray[index] === true) {
          this.$set(this.cellStatusArray, index, false)
        }
      }
    },
    /** 打开当前单元格编辑状态 */
    _openCurrentCellEditableStatus(row, col) {
      const index = row * this.columnsNumber + col
      if (this.cellStatusArray[index] === false) {
        this.$set(this.cellStatusArray, index, true)
        this._updateCurrentRowAndCurrentColumn(row, col)
      }
    },
    /** 更新当前行和当前列索引 */
    _updateCurrentRowAndCurrentColumn(row, col) {
      this.currentRow = row
      this.currentColumn = col
    },
  },

  mounted() {
    if (this.rows.length === 1) {
      this.activeNames = [0]
    }
  },

  created() {
    this._initCellStatusArray()
    this.orginrow = _.cloneDeep(this.rows)
  },
  watch: {
    /** 监听行数变化，如果行数增加，对应的单元格状态数组也要发生改变 */
    rows() {
      const length = this.rowsNumber * this.columnsNumber
      if (this.cellStatusArray.length !== length) {
        this._initCellStatusArray()
      }
    },
    $route(to, from) {
      if (to.path.indexOf('/page') > -1) {
        setTimeout(() => {
          if (this.rows.length === 1) {
            this.activeNames = [0]
          } else {
            this.activeNames = []
          }
        }, 600)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.table-comp {
  display: block;
}

.component-container>>>.el-table th {
  padding: 0;
}

.component-container>>>.el-table td {
  padding: 1px 0;
}

.component-container>>>.el-collapse {
  width: 100%;
  border-bottom: none;
}

.component-container>>>.el-collapse .el-collapse-item__header {
  font-size: 16px;
}

.component-container>>>.el-collapse .el-collapse-item__content {
  font-size: 16px;
}

.button {
  margin: 10px 5px;
}

.cell-content {
  padding: 0 8px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #DCDFE6;
  display: block;
  background-color: #F5F7FA;
}

.list {
  width: 100%;
  margin-bottom: 20px;
}

.list_row {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.list_label {
  label {
    margin-left: 0;
  }
}

.list_cont {
  min-height: 20px;
}
</style>
